export const isDark = false;

const PRIMARY_LIGHT = "#f2f2f2";
const PRIMARY_DARK = "#f2f2f2";
const SECONDARY_LIGHT = "#fff";
const SECONDARY_DARK = "#FFF";


export const PRIMARY = isDark ? PRIMARY_DARK : PRIMARY_LIGHT;
export const SECONDARY = isDark ? SECONDARY_DARK : SECONDARY_LIGHT;
export const ACCENT = "#C60017";
export const TEXT_COLOR = "#03045e"
export const WHITE = SECONDARY_LIGHT;
export const BLACK = TEXT_COLOR;


// ACTIONS
export const SUCCESS = '#3adb76';
export const WARNING = '#ffae00';
export const ALERT = '#cc4b37';
export const INFO = "#00B0F0";

// GRAYSCALE
export const GRAY_LIGHT = '#e6e6e6';
export const GRAY_MEDIUM = '#cacaca';
export const GRAY_DARK = '#8a8a8a';


